export default __webpack_public_path__ + "static/media/work-bg.6aa588ce.png";